import { useEffect, useState } from "react";
import ProctoringSvg from "../../../Svg/ProctoringSvg";
import EvidencePopup from "./EvidencePopUp";

export const ProtectoringIconsName = (data) => {
  // console.log("data in ProtectoringIconsName", data);
  if (data.includes("Student face not verified")) {
    return "faceNotVerified";
  } else if (data.includes("Student looking in different direction")) {
    return "headMovement";
  } else if (data.includes("Multiple people detected")) {
    return "multiPeople";
  } else if (data.includes("Mobile phone detected")) {
    return "mobile";
  } else if (data.includes("External device detected")) {
    return "externalDevice";
  }
};

const TrackTimelineDetails = (Props) => {
  const [mergedTimeline, setMergedTimeline] = useState([]);
  const [activeEvidenceIndex, setActiveEvidenceIndex] = useState(null);
  const [evidanceData, setEvidanceData] = useState(null);
  const changeTimeandDate = (timestamp) => {
    const dateObj = new Date(timestamp);
    const time = dateObj.toLocaleTimeString(); // returns "HH:MM:SS AM/PM"
    return time;
  };

  useEffect(() => {
    const processProctoringData = (Props.proctoredData || []).map((item) => {
      const issues = [];

      if (
        parseInt(item.facedetected) !== 1 ||
        parseInt(item.dpfacedetected ?? 1) !== 1
      )
        issues.push("Student face not verified");
      if (parseInt(item.faceorientationnormal) !== 0)
        issues.push("Student looking in different direction");
      if (
        parseInt(item.multifacedetected) !== 0 ||
        parseInt(item.dpmultifaces ?? 0) !== 0
      )
        issues.push("Multiple people detected");
      if (
        item.phonedetected !== "0" ||
        parseInt(item.dpphonedetected ?? 0) !== 0
      )
        issues.push("Mobile phone detected");
      if (
        item.externaldevice !== "0" ||
        parseInt(item.dpexternaldevices ?? 0) !== 0
      )
        issues.push("External device detected");

      return {
        ...item,
        type: "proctoring",
        timestamp: item.timestamp,
        eventtext:
          issues.length > 0
            ? issues.join(", ")
            : "No suspicious activity detected",
        issues: issues,
      };
    });

    const processedEventLogs = (Props.eventLogData || []).map((item) => ({
      type: "event",
      timestamp: item.createdTimeStamp?.split(".")[0], // remove microseconds if any
      eventtext: item.eventtext,
    }));

    const allLogs = [...processedEventLogs, ...processProctoringData];

    allLogs.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

    setMergedTimeline(allLogs);
  }, [Props.eventLogData, Props.proctoredData]);

  // console.log("Merged Timeline Data: ", mergedTimeline);

  const ProtectoringCondition = (data) => {
    if (
      data.includes("Student face not verified") ||
      data.includes("Student looking in different direction") ||
      data.includes("Multiple people detected") ||
      data.includes("Mobile phone detected") ||
      data.includes("External device detected")
    ) {
      return true;
    } else {
      return false;
    }
  };

  const groupByDate = (timeline) => {
    const grouped = timeline.reduce((acc, item) => {
      const date = new Date(item.timestamp);
      const dateStr = date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

      if (!acc[dateStr]) {
        acc[dateStr] = [];
      }
      acc[dateStr].push(item);
      return acc;
    }, {});

    return grouped;
  };

  return (
    <div className="collapsible_userDetails">
      {/* <div className="header" {...getToggleProps()}> */}
      {/* <span className="timeline-header">Activity</span> */}
      {/* <span className="timeline-header-arrowIcon">
            <FontAwesomeIcon
              className="arrowIcon"
              icon={isExpanded ? faChevronDown : faChevronRight}
            />
          </span> */}
      {/* </div> */}
      <div className="details">
        <div className="content">
          {mergedTimeline.length > 0 ? (
            Object.entries(groupByDate(mergedTimeline)).map(
              ([date, entries]) => (
                <div key={date} className="date-group">
                  <div className="date-header">{date}</div>
                  {entries.map((data, index) => {
                    const isSuspicious = ProtectoringCondition(data.eventtext);
                    const isActive = index === activeEvidenceIndex;

                    return (
                      <div
                        className={`activity-log ${
                          isSuspicious ? "warning" : ""
                        }`}
                        key={index}
                      >
                        <span className="activity-log-timestamp">
                          {changeTimeandDate(data.timestamp)}
                        </span>

                        <span className="activity-log-eventtext">
                          {isSuspicious ? (
                            <>
                              <span
                                role="img"
                                aria-label="warning"
                                style={{ display: "flex", gap: "3px" }}
                              >
                                {data.issues.map((issue, index) => (
                                  <ProctoringSvg
                                    key={index}
                                    type={ProtectoringIconsName(issue)}
                                  />
                                ))}
                              </span>{" "}
                              {data.eventtext} <ProctoringSvg type="warning" />
                            </>
                          ) : (
                            data.eventtext
                          )}
                        </span>

                        {isSuspicious && (
                          <span
                            className={`activity-log-evidence ${
                              isActive && evidanceData ? "warning" : ""
                            }`}
                            onClick={() => {
                              if (isActive) {
                                // toggle off
                                setActiveEvidenceIndex(null);
                                setEvidanceData(null);
                              } else {
                                // open new
                                setActiveEvidenceIndex(index);
                                setEvidanceData(data);
                              }
                            }}
                          >
                            <ProctoringSvg type="eye" /> Evidence
                          </span>
                        )}

                        {isActive && evidanceData && (
                          <EvidencePopup
                            data={evidanceData}
                            onClose={() => setActiveEvidenceIndex(null)}
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              )
            )
          ) : (
            <p>No logs available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrackTimelineDetails;
